import { supabase } from '../db/engine';

// Enlaces FIRMADOS temporales para ver/descargar documentos de Storage.
//
// Los buckets son privados: un documento (cédula, póliza, endoso…) solo se abre
// con un enlace firmado que se genera al vuelo para el usuario con sesión y caduca.
// Ya NO se usan URLs públicas (`getPublicUrl`), que dejaban los archivos accesibles
// por link sin login. Ver "Autenticación y RLS" en CLAUDE.md.

const BUCKET_DEFECTO = 'solicitud-archivos';

// De una URL de Supabase Storage (pública o firmada) saca { bucket, path }.
// Si la entrada no es una URL de Supabase, se trata como path suelto (ej. el
// `documentos.storage_path` que guarda DocManager) en el bucket por defecto.
export function parseStorage(urlOrPath) {
  if (!urlOrPath) return null;
  const s = String(urlOrPath);
  const marca = '/storage/v1/object/';
  const i = s.indexOf(marca);
  if (i === -1) {
    return { bucket: BUCKET_DEFECTO, path: s.replace(/^\/+/, '') };
  }
  // .../object/public/<bucket>/<path>   |   .../object/sign/<bucket>/<path>?token=...
  let resto = s.slice(i + marca.length).split('?')[0];
  const partes = resto.split('/');
  partes.shift();                        // "public" | "sign" | "authenticated"
  const bucket = partes.shift();
  const path = decodeURIComponent(partes.join('/'));
  return { bucket, path };
}

// URL firmada temporal (por defecto 2 minutos) para el documento.
export async function urlFirmada(urlOrPath, segundos = 120) {
  const loc = parseStorage(urlOrPath);
  if (!loc?.path) return null;
  const { data, error } = await supabase.storage.from(loc.bucket).createSignedUrl(loc.path, segundos);
  if (error) { console.error('createSignedUrl:', error); return null; }
  return data?.signedUrl || null;
}

// Abre el documento en una pestaña nueva. Abre la pestaña de inmediato (dentro del
// clic del usuario, para que el bloqueador de popups no la corte) y le pone la URL
// firmada cuando llega.
export async function abrirDocumento(urlOrPath) {
  if (!urlOrPath) return;
  // OJO: NO usar 'noopener' aquí — con noopener window.open devuelve null y la
  // pestaña queda en blanco. Necesitamos la referencia para ponerle la URL firmada.
  const win = window.open('about:blank', '_blank');
  const url = await urlFirmada(urlOrPath, 120);
  if (!url) { if (win) win.close(); alert('No se pudo abrir el documento. Intenta de nuevo.'); return; }
  if (win) win.location.href = url; else window.open(url, '_blank');
}
